/**
 * Regex pattern to match only letters, including accented characters and spaces.
 */

export const onlyLettersPattern = /[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g

export const CLEAN_DECIMAL_NUMBERS = /[^,0-9]/g
export const CLEAN_DNI = /^0+|[^0-9kK]+/g
export const DECIMAL_NUMBERS = /^[0-9]+(,[0-9]{1,2})?$/
export const DNI_FOREIGN_CHECK = /^[a-zA-Z0-9-]*$/
